export default __webpack_public_path__ + "static/media/GreiffModernRf.8a9e8c2b.jpg";